export default "__VITE_ASSET__BcTctC0q__"